import React from "react";

export const PasswordConfirmationSetterContext = React.createContext({
	setShowPasswordConfirmation: (value: boolean) => {},
});

export const PasswordConfirmationGetterContext = React.createContext<{
	showPasswordConfirmation: boolean;
}>({ showPasswordConfirmation: false });
